import { FormControl, Grid, InputLabel, MenuItem, Select } from '@mui/material';
import { TemplateType } from 'compobot-dynamic-page';
import { Control, Controller, FieldError } from 'react-hook-form';
import { CreateGuiVersionType } from 'types/compobotGuiVersion.type';

interface DropdownSectionProps {
  control: Control<CreateGuiVersionType>;
  error: FieldError | undefined;
  name: string;
  fieldName: keyof CreateGuiVersionType;
  options: { value: TemplateType | string; label: string }[];
  defaultValue: TemplateType | string;
}

const DropdownSection = ({
  control,
  error,
  options,
  name,
  fieldName,
  defaultValue,
}: DropdownSectionProps) => (
  <Grid item xs={12}>
    <FormControl fullWidth error={!!error}>
      <InputLabel id="template-type-label">{name}</InputLabel>
      <Controller
        name={fieldName}
        control={control}
        defaultValue={defaultValue}
        rules={{ required: 'Template type is required' }}
        render={({ field }) => (
          <Select
            {...field}
            labelId="template-type-label"
            label="Template Type"
          >
            {options.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </Select>
        )}
      />
    </FormControl>
  </Grid>
);

export default DropdownSection;
